var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes,attrs:{"id":"app"}},[(!_vm.isSignIn)?_c('Navigation',{attrs:{"showLinks":_vm.showAccountLink}}):_vm._e(),_c('router-view'),(!_vm.is404)?_c('PageFooter'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }